import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import { shippingService } from '../services/shipping.service';
import type { CreateShippingRateData } from '../types/shipping.types';

export function useCreateShippingRate() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: (data: CreateShippingRateData) => shippingService.createShippingRate(data),
    onSuccess: () => {
      toast.success(t('shipping.rateCreated', { defaultValue: 'Shipping rate created successfully' }));
      queryClient.invalidateQueries({ queryKey: ['shippingRates'] });
      navigate('/shipping');
    },
    onError: (error) => {
      console.error('Failed to create shipping rate:', error);
      toast.error(t('common.error', { defaultValue: 'An error occurred' }));
    },
  });
}
